
import async from "@preact/async-loader/async.js";

function load(cb) {
  import("./index.jsx?preact-async-route").then(mod => {
    cb(mod);
  });
}

export default async(load);
